export enum AddressFieldNames {
  StreetLine1 = "streetLine1",
  StreetLine2 = "streetLine2",
  City = "city",
  StateOrProvince = "stateOrProvince",
  ZipCode = "zipCode",
  Country = "country",
}
